
<script>
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  name : 'c_chart_pie_tickets_pendientes_por_asesor',
  props : {
    resueltos : {
      type   : Array,
      default: []
    },
    pendientes : {
      type   : Array,
      default: []
    }
  },
  data () {
    return {
      listaData : [],
      chartData: {
        labels  : ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
        datasets: [
          {
            label          : `Andres Mesias`,
            data           : this.resueltos,
            fill           : false,
            borderColor    : this.$vuetify.theme.themes.light.success,
            backgroundColor: this.$vuetify.theme.themes.light.success,
            borderWidth    : 1
          },
          {
            label          : `Giancarlo Davila`,
            data           : this.pendientes,
            fill           : false,
            borderColor    : this.$vuetify.theme.themes.light.primary,
            backgroundColor: this.$vuetify.theme.themes.light.primary,
            borderWidth    : 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            },
            ticks : {
              fontSize: 12
            }
          }]
        },
        onClick:this.handle,
        legend: {
          display: true
        },
        responsive         : true,
        maintainAspectRatio: false,
        query: {
          titulo           : '',
          descripcion      : '',
          tipo             : '-1',
          desde            : '',
          hasta            : '',
          numero           : '',
          estado           : 0,
          codigoCliente    : '',
          serie            : '',
          modelo           : '',
          zona             : '-1',
          area             : '-1',
          abierto          : '-1',
          ingresoATaller   : '-1',
          tipoReporte      : 'basico'
        }
      }
    }
  },
  mounted () {
    var vm = this
    vm.render()
  },
  methods : {
    handle (point, event) {
      // var vm = this
      var item = event[0]
      if (item) {
        console.log('item', item)
        // var index        = item._index
        // var estado       = vm.listaData[index]
        // vm.query.abierto = 1
        // vm.query.tipo    = vm.tipo.toLowerCase()
        // var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
        // window.open(url.href, '_blank')
      }
      // var vm = this
      // var item = event[0]
      // if (item) {
      //   var index        = item._index
      //   var estado       = vm.listaData[index]
      //   vm.query.estado  = estado.estado
      //   vm.query.abierto = 1
      //   vm.query.tipo    = vm.tipo.toLowerCase()
      //   // vm.$router.push({ path: "/DetailsBook", query: { key } });
      //   var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
      //   window.open(url.href, '_blank')
    },
    render () {
      var vm = this
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark
      vm.renderChart(vm.chartData, vm.options)
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas
  max-height: 250px !important;
</style>



// WEBPACK FOOTER //
// c_chart_pie_tickets_pendientes_por_asesor.vue?7569644b